import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog'
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions'
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent'
import DialogContentText from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContentText'
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import ui from 'redux-ui'
import {SET_REVIEWS_ENABLED_DIALOG_STATUS} from '../AppDetails/Redux/ActionTypes'
import Spacer20 from "../../Misc/Spacer20.js.jsx"

@ui({
  state: {
    open: false
  },
  reducer: (state, action) => {
    switch (action.type) {
      case SET_REVIEWS_ENABLED_DIALOG_STATUS:
        return state.set('open', action.status)
    }
    return state
  }
})

@connect(
  null,
  dispatch => ({
    onClose: () => {
      dispatch({type: SET_REVIEWS_ENABLED_DIALOG_STATUS, status: false})
    }
  })
)
export default class ReviewsAppEnabledDialog extends Component {

  render() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={this.props.ui.open}
        onClose={() => {
          this.props.onClose()
        }}
      >
        <DialogTitle>
          This app is now active
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your customers will start receiving the opportunity to leave a review for you when a job
            is marked as finished.
          </DialogContentText>
          <Spacer20/>
          <DialogContentText>
            YOUR NEXT STEP: head to 'My Apps' and click on Reviews to get your Google & Facebook accounts hooked up
          </DialogContentText>
          <Spacer20/>
          <img style={{width: '100%'}}
               alt="how to find reviews"
               src="https://s3-us-west-1.amazonaws.com/housecall-general/Assets/Apps+Page/how_to_find_reviews.gif"/>
        </DialogContent>
        <DialogActions>
          <Button
            color='primary'
            onClick={() => {
              this.props.onClose()
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

}
